import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useSiteContent() {
  return useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await api.get("/site-content")).data,
  });
}

export function useServices() {
  return useQuery({
    queryKey: ["services"],
    queryFn: async () => (await api.get("/services")).data,
  });
}

export function useGallery(category, featured) {
  return useQuery({
    queryKey: ["gallery", category, featured],
    queryFn: async () => {
      const params = {};
      if (category) params.category = category;
      if (featured) params.featured = true;
      return (await api.get("/gallery", { params })).data;
    },
  });
}

export function useTestimonials() {
  return useQuery({
    queryKey: ["testimonials"],
    queryFn: async () => (await api.get("/testimonials")).data,
  });
}
